import { commaFormatString } from '@/helpers'

export const formatIndex = function (index) {
  return commaFormatString(String(index))
}

export const formatRating = function (rating) {
  return commaFormatString(String(rating.toFixed(3)))
}

export const formatAudienceSize = function (size) {
  return commaFormatString(size)
}



// WEBPACK FOOTER //
// ./src/app/appComponents/workbench/lasGraphs/viewership/helpers/index.js